<template>
    <div class="footer-main">
        <div class="o-container">
            <article>
                <img :src="require(`@/assets/img/${theme}.svg`)" alt="main logo"/>
                <div style="width: 400px">
                    <small class="u-display-block">
                        <span class="u-display-block mb--">
                            {{copyright}} <br />
                        </span>
                        <div class="o-flex o-flex--start">
                            <svg class="mt-- mr-" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.167 15.167" width="12.167"><g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.167" data-name="Icon feather-map-pin"><path d="M11.583 6.311c0 4.455-5.5 8.273-5.5 8.273s-5.5-3.818-5.5-8.273a5.617 5.617 0 0 1 5.5-5.728 5.617 5.617 0 0 1 5.5 5.728Z" data-name="Path 24"></path><path d="M7.917 6.31a1.872 1.872 0 0 1-1.834 1.908A1.872 1.872 0 0 1 4.25 6.31a1.872 1.872 0 0 1 1.833-1.909A1.872 1.872 0 0 1 7.917 6.31Z" data-name="Path 25"></path></g></svg>
                            <p class="mb--">{{$t('payment.address')}} <br> {{$t('payment.registration')}}</p>
                        </div>
                        This site is protected by reCAPTCHA and the Google
                        <a class="clr-gold" style="font-size: inherit" href="https://policies.google.com/privacy">Privacy Policy</a> and
                        <a class="clr-gold" style="font-size: inherit" href="https://policies.google.com/terms">Terms of Service</a> apply.
                    </small>

                </div>
            </article>
            <article>
                <ul class="link-list">
                    <li><router-link :to="{name: 'privacy'}">{{$t('navigation.footer.privacy')}}</router-link></li>
                    <li class="divider"></li>
                    <li><router-link :to="{name: 'terms'}">{{$t('navigation.footer.terms')}}</router-link></li>
                    <li class="divider"></li>
                    <li><router-link :to="{name: 'imprint'}">{{$t('general.imprint.imprint')}}</router-link></li>
                    <li class="divider"></li>
                    <li><a href="https://sugardaddy.date/en/customer-support-en/" target="_blank">{{$t('general.imprint.contact')}}</a></li>
                </ul>
                <ul class="mb0 partners-link">
                    <li><img src="@/assets/img/amazon.svg" alt="amazon"></li>
                    <li><img src="@/assets/img/ssl.svg" alt="ssl"></li>
                    <li><img src="@/assets/img/verified-members.svg" alt="verified"></li>
                    <li><img src="@/assets/img/master.svg" alt="master" width="38"></li>
                    <li><img src="@/assets/img/visa.svg" alt="visa" width="75"></li>
                    <li><img src="@/assets/img/verified-visa.svg" alt="verified-visa" width="53"></li>
                    <li><img src="@/assets/img/MasterCard_SecureCode.webp" alt="MasterCard_SecureCode" width="75"></li>

                </ul>
            </article>
        </div>
    </div>
</template>

<script>

import ThemeMixin from "@/mixins/ThemeMixin";

export default {
    name: "Footer",
    mixins: [ThemeMixin],
    created() {
        this.copyright = process.env.VUE_APP_COPYRIGHT
    }
}
</script>

<style scoped lang="scss">
    .footer-main {
        padding: 30px 0;

    }

    .o-container {
        display: flex;
        align-items: center;
        justify-content: space-between;

        >article {
            &:first-child {
                display: flex;
                align-items: flex-start;

                img {
                    min-width: 60px;
                    margin-right: 20px;
                }

                small {
                    display: block;
                    max-width: 350px;
                    color: #000000;
                }


            }
            .partners-link {
                display: flex;
                align-items: flex-end;


                li {
                    &:not(:last-child) {
                        margin-right: 10px;
                    }
                }

                @media(max-width: 991px) {
                    flex-wrap: nowrap;
                }

                @media(max-width: 768px) {
                    flex-wrap: wrap;
                }
            }
            .link-list {
                display: flex;
                font-size: 16px;
                color: $color-type7;
                margin-bottom: 10px;

                @media(max-width: 991px) {
                    flex-wrap: nowrap;
                    justify-content: flex-start;
                }

                a {
                    color: #000000;
                    font-size: 14px;

                    &:hover {
                        color: $color-type19;
                    }
                }
            }
        }
    }

    .divider {
        margin: 0 5px;
        height: 18px;
        width: 1px;
        background-color: #000000;
    }

</style>